import { NavLink, Outlet } from "react-router-dom";
import { BrandWordmark } from "./BrandWordmark";
import { PageMeta } from "./PageMeta";
import { useAdminShortcut } from "../hooks/useAdminShortcut";

const publicLinks = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/experience", label: "Experience" },
  { to: "/contact", label: "Contact", cta: true },
] as const;

export function Layout() {
  const onAdminShortcut = useAdminShortcut();

  return (
    <div className="app-shell">
      <PageMeta />
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <header className="site-header">
        <div className="header-accent" aria-hidden />
        <div className="container site-header-inner">
          <div className="header-row">
            <NavLink to="/" className="brand" end aria-label="SpecOps Engineers home">
              <BrandWordmark variant="header" />
            </NavLink>
          </div>
          <nav id="primary-nav" className="nav" aria-label="Primary">
            <div className="nav-links">
              {publicLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={"end" in link ? link.end : undefined}
                  className={({ isActive }) =>
                    [
                      "nav-link",
                      isActive ? "nav-link--active" : "",
                      "cta" in link && link.cta ? "nav-link--cta" : "",
                    ]
                      .filter(Boolean)
                      .join(" ")
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </div>
          </nav>
        </div>
      </header>
      <main id="main-content" className="site-main" tabIndex={-1}>
        <div className="container page-container">
          <Outlet />
        </div>
      </main>
      <footer className="site-footer">
        <div className="container footer-inner">
          <div className="footer-brand">
            <BrandWordmark variant="footer" />
            <p className="footer-copy" onClick={onAdminShortcut}>
              © {new Date().getFullYear()} SpecOps Engineers LLC
            </p>
          </div>
          <div className="footer-links">
            <NavLink to="/privacy">Privacy</NavLink>
          </div>
        </div>
      </footer>
    </div>
  );
}
